import { useCallback, useMemo } from "react";
import { useAtom } from "jotai";
import { uploadFilesAtom } from "@/atom/upload";


export const useUploadedFiles = () => {
    const [uploadedFiles, setUploadedFiles] = useAtom(uploadFilesAtom);

    const add = useCallback((file: File, url: string) => {
        setUploadedFiles(prev => ({ ...prev, [url]: file }));
    }, [setUploadedFiles]);

    const remove = useCallback((url: string) => {
        setUploadedFiles(prev => {
            const { [url]: _, ...rest } = prev;
            URL.revokeObjectURL(url);
            return rest;
        });
    }, [setUploadedFiles]);

    const clear = useCallback(() => {
        setUploadedFiles(prev => {
            Object.keys(prev).forEach(key => {
                URL.revokeObjectURL(key);
            });
            return {};
        });
    }, [setUploadedFiles]);

    return useMemo(() => {
        return {
            files: uploadedFiles,
            add,
            remove,
            clear
        };
    }, [uploadedFiles, add, remove, clear]);
};
